export const signOutActionConstants={
    SIGNOUT_IN_PROGRESS:"SIGNOUT_IN_PROGRESS",
    SIGNOUT_COMPLETE:"SIGNOUT_COMPLETE"
}